export default __webpack_public_path__ + "static/media/nav_img_11.bb933eac.jpg";